const normalizeString = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value !== 'string') return value;
  return value;
};

export const normalizeJournalistPayload = (payload) => {
  if (!payload || typeof payload !== 'object') return payload;

  const normalized = { ...payload };

  Object.entries(normalized).forEach(([key, value]) => {
    if (typeof value === 'string' || value === null) {
      normalized[key] = normalizeString(value);
      return;
    }

    if (Array.isArray(value)) {
      normalized[key] = value
        .map((item) => (typeof item === 'string' || item === null ? normalizeString(item) : item))
        .filter((item) => item !== null);
    }
  });

  return normalized;
};
